export default "__VITE_ASSET__85759b42__"